import React from 'react'
import { BiExpandHorizontal, BiCollapseHorizontal, BiExpandVertical, BiCollapseVertical } from 'react-icons/bi'
import cn from 'classnames'
import type { ListSettings } from 'types/shapes'

import 'components/graph/controls/controls.less'

type SpacingControlProps = {
  mode: 'expand' | 'contract'
  direction: ListSettings['direction']
  onClick: () => void
  disabled?: boolean
}

const SpacingControl = ({ mode, direction, onClick, disabled }: SpacingControlProps) => {
  const label = mode === 'expand' ? 'Increase spacing' : 'Decrease spacing'

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (disabled) return
    onClick()
  }

  const Icon = direction === 'horizontal'
    ? (mode === 'expand' ? BiExpandHorizontal : BiCollapseHorizontal)
    : (mode === 'expand' ? BiExpandVertical : BiCollapseVertical)

  return (
    <div className={cn('control', `spacing-${mode}`)} data-graph-type="control" title={label}>
      <a className={cn('icon', { disabled })} onClick={handleClick}>
        <Icon aria-hidden />
        <span className="sr-only">{label}</span>
      </a>
    </div>
  )
}

export default SpacingControl
